/**
 * @ngdoc component
 * @name returns.component:itxReturnConfirmation
 * @description
 * Component description
 */
(function () {
    'use strict';

    var itxReturnConfirmation = {
        bindings: {},
        controllerAs: '$ctrl',
        controller: itxReturnConfirmationCtrl,
        templateUrl: 'return-confirmation.component.html'
    };

    itxReturnConfirmationCtrl.$inject = [];

    function itxReturnConfirmationCtrl() {
        var _this = this;

        _this.$onInit = function () {};
    }

    angular.module('itxApp.legacy').component('itxReturnConfirmation', itxReturnConfirmation);
})();
